import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getData, getKCISData } from "../../../services/index";
import { Modal, Button, Select } from "antd";
import { Redirect } from "react-router-dom";
import { Drawer, Menu, Input, message } from "antd";
import "remixicon/fonts/remixicon.css";
import {
  MailOutlined,
  AppstoreOutlined,
  PhoneFilled,
  SettingOutlined,
  UserOutlined,
  BellOutlined,
  LockOutlined,
  LogoutOutlined,
} from "@ant-design/icons";

import notification_fill from "../../../assets/images/icon/notification_fill.png";
import user from "../../../assets/images/icon/user.png";
import wifi from "../../../assets/images/icon/no-wifi.png";
import delete_img from "../../../assets/images/icon/delete.png";

import { auth, db, messaging } from "../../../firebase";
import { getToken, getMessaging, onMessage } from "firebase/messaging";

import {
  Nav,
  Navbar,
  NavbarBrand,
  Collapse,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledCarousel,
  Progress,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
} from "reactstrap";
import $ from "jquery";

import dark_logo from "../../../assets/images/logo/logo.png";
import logo from "../../../assets/images/icon/logo.png";
import kcis_logo from "../../../assets/images/icon/logo.png";
import user_img from "../../../assets/images/icon/person.png";

const { TextArea } = Input;
const { SubMenu } = Menu;

const mapStateToProps = (state) => ({
  ...state,
});

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectToReferrer: false,
      noti_visible: false,
      visible: false,
      placement: "left",
      current: "mail",
      user_name: "",
      email: "",
      visible_1: true,
      school_name: "",
      name: "",
      dash_url: "",
      phone: "",
      locality: "",
      city: "",
      logo: "",
      type: "",
      profile_pic: "",
      error_text: "",
      today_details: "",
      notification_list: [],
      notification_count: 0,
      is_multiple: 0,
      is_notify: 0,
      check_in_status: 0,
      master_school_list: [],
      school_access: [],
      is_app: false,
      isOnline: navigator.onLine,
      error_visible: false,
      staff_visible: false,
      data_list: [],
      modalwidth: 480,

      main_link: "",
      dayplan_link: "",
      aToken: "",
      main_menu: "",
      sub_menu: "",
      fees_request_count: 0,
      student_archive_count: 0,
      gate_pass_count: 0,
      cash_count: 0,
      refund_request_count: 0,
      request_cert_count: 0,
      open_concern_count: 0,
      process_concern_count: 0,
      kit_order_count: 0,
      indi_order_count: 0,
      reconc_count: 0,
      staff_leave_count: 0,
      student_leave_count: 0,
      permission: [],
      openMenus: {},
    };
    this.logout = this.logout.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
  }

  toggleMenu = (menuKey) => {
    this.setState((prevState) => ({
      openMenus: {
        ...prevState.openMenus,
        [menuKey]: !prevState.openMenus[menuKey],
      },
    }));
  };

  change_school(event) {
    var storedArray = JSON.parse(localStorage.getItem("schoolData"));
    var user_id = storedArray["data"][0]["user_id"];
    var school_id = event;
    this.setState({ school_id: school_id });
    var app = {
      school_id: school_id,
      user_id: user_id,
    };
    getData("auth/school_change", app).then((result) => {
      if (result.status == 200) {
        let responseJson = result;
        if (responseJson.data) {
          localStorage.setItem("schoolData", JSON.stringify(responseJson));
          var name = result["data"][0]["user_name"];
          var phone = result["data"][0]["phone"];
          var email = result["data"][0]["email"];
          var user_id = result["data"][0]["user_id"];
          var school_id = result["data"][0]["school_id"];
          var short_name = result["data"][0]["short_name"];
          var type = result["data"][0]["type"];
          var permission = result["data"][0]["permission"];
          this.setState({
            name: name,
            phone: phone,
            email: email,
            user_id: user_id,
            school_id: school_id,
            short_name: short_name,
            type: type,
            permission: permission,
          });
          var uri = window.location.toString();
          if (uri.indexOf("?") > 0) {
            var clean_uri = uri.substring(0, uri.indexOf("?"));
            window.history.replaceState({}, document.title, clean_uri);
            window.location.reload(false);
          }
        }
      }
    });
  }

  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  noti_showDrawer = () => {
    this.setState({
      noti_visible: true,
    });
    var erp_id = localStorage.getItem("erp_id");
    var storedArray = JSON.parse(localStorage.getItem("schoolData"));
    var user_id = storedArray["data"][0]["user_id"];
    var school_id = storedArray["data"][0]["school_id"];
    var app = { user_id: user_id, school_id: school_id, erp_id: erp_id };
    getData("erp/all_notification_list", app).then((result) => {
      let responseJson = result;
      if (responseJson.data) {
        if (result["status"] == 200) {
          this.setState({
            notification_list: result["data"],
            notification_count: result["count"],
            is_notify: 1,
          });
        } else {
          this.setState({
            notification_list: [],
            notification_count: 0,
            is_notify: 1,
          });
        }
      }
    });
  };

  noti_onClose = () => {
    this.setState({
      noti_visible: false,
    });
  };

  onChange = (e) => {
    this.setState({
      placement: e.target.value,
    });
  };

  showModal = () => {
    this.setState({
      visible_1: true,
    });
  };

  handleOk = (e) => {
    console.log(e);
    this.setState({
      visible_1: false,
    });
  };

  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible_1: false,
    });
  };

  logout() {
    localStorage.setItem("schoolData", "");
    localStorage.clear();
    window.location.href = "/login/";
  }

  checkInternetSpeed() {
    const networkInfo =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;
    if (networkInfo) {
      const connectionType = networkInfo.effectiveType; // "4g", "3g", "2g", etc.
      const rtt = networkInfo.rtt;
      if (connectionType === "slow-2g" || rtt > 500) {
        setTimeout(() => {
          this.setState({ is_slow_internet: true });
        }, 100);
      } else {
        setTimeout(() => {
          this.setState({ is_slow_internet: false });
        }, 100);
      }
    }
    setTimeout(() => {
      this.setState({ isOnline: navigator.onLine });
    }, 100);
  }

  componentDidMount() {
    this.checkData();
    this.checkInternetSpeed();
    setInterval(() => {
      this.checkInternetSpeed();
    }, 5000);

    var new_url = window.location.pathname.split("/");
    this.setState({
      dash_url: new_url[1],
    });

    if (!localStorage.getItem("schoolData")) {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });

      if (params.mtoken != null) {
        let auth_token = params.mtoken;
        var app = { token: auth_token };
        getData("kidzonia_parents/check_school_token", app).then((result) => {
          let responseJson = result;
          if (responseJson) {
            if (result["status"] == 200) {
              localStorage.setItem("schoolData", JSON.stringify(responseJson));
              this.checkData();
              //window.location.reload();
            } else {
              localStorage.setItem("schoolData", "");
              localStorage.clear();
              window.location.href = "/app_404?mtoken=" + auth_token;
            }
          }
        });
      } else {
        localStorage.setItem("schoolData", "");
        localStorage.clear();
        window.location.href = "/login/";
      }
    } else {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
      if (params.mtoken != null) {
        let auth_token = params.mtoken;
        var app = { token: auth_token };
        getData("kidzonia_parents/check_school_token", app).then((result) => {
          let responseJson = result;
          if (responseJson) {
            if (result["status"] == 200) {
              localStorage.setItem("schoolData", JSON.stringify(responseJson));
            } else {
              localStorage.setItem("schoolData", "");
              localStorage.clear();
              window.location.href = "/app_404?mtoken=" + auth_token;
            }
          }
        });
      }

      if (params.mtoken != null) {
        this.setState({ is_app: true });
        this.checkData();
      } else {
        if (localStorage.getItem("schoolData")) {
          var erp_id = localStorage.getItem("erp_id");
          var erp_type = localStorage.getItem("erp_type");
          var storedArray = JSON.parse(localStorage.getItem("schoolData"));
          this.setState({
            erp_id: erp_id,
            erp_type: erp_type,
            short_name: storedArray["data"][0]["short_name"],
            user_id: storedArray["data"][0]["user_id"],
            user_name: storedArray["data"][0]["user_name"],
            phone: storedArray["data"][0]["phone"],
            type: storedArray["data"][0]["type"],
            school_id: storedArray["data"][0]["school_id"],
            is_multiple: storedArray["data"][0]["is_multiple"],
            school_access: storedArray["data"][0]["school_access"],
            staff_type: storedArray["data"][0]["staff_type"],
            email: storedArray["data"][0]["email"],
            phone: storedArray["data"][0]["phone"],
            profile_pic: storedArray["data"][0]["profile_pic"],
          });
          this.setState({ is_app: false });
          this.checkData();
        }
      }
    }
    onMessage(messaging, (payload) => {
      if (payload.data.is_show) {
        if (payload.data.is_show == 1) {
          const notificationTitle = payload.data.title;
          const notificationOptions = {
            body: payload.data.body,
            icon: payload.data.icon,
            message: payload.data.message,
            click_action: payload.data.notification_url,
          };
          var notification = new Notification(
            notificationTitle,
            notificationOptions
          );
        }
      }
    });
  }

  checkData() {
    if (localStorage.getItem("schoolData")) {
      var storedArray = JSON.parse(localStorage.getItem("schoolData"));
      this.setState({ user_id: storedArray["data"][0]["user_id"] });
      var user_id = storedArray["data"][0]["user_id"];
      var school_id = storedArray["data"][0]["school_id"];
      var type = storedArray["data"][0]["type"];

      var erp_id = localStorage.getItem("erp_id");
      var permission = storedArray["data"][0]["permission"];
      console.log("permission: ",permission);

      var staff_designation = storedArray["data"][0]["staff_designation"];
      this.setState({
        type: type,
        school_id: school_id,
        erp_id: erp_id,
        permission: permission,
        user_id: user_id,
        staff_designation: staff_designation,
      });

      var app = { user_id: user_id, school_id: school_id, erp_id: erp_id };

      if (type == "admin") {
        const queryParams = new URLSearchParams(window.location.search);
        var new_school_id = queryParams.get("s");

        if (new_school_id != "" && new_school_id != null) {
          setTimeout(() => {
            this.change_school(new_school_id);
          }, 500);
        }
      }

      if (type == "admin" || type == "school") {
      } else {
        getKCISData("common/check_staff_login", app).then((result) => {
          let responseJson = result;
          if (result["status"] == 200) {
            this.setState({
              check_in_status: result["check_in"],
            });
            if (result["check_in"] == 0) {
              this.errorShow(result["error_sub_msg"]);
            }
          }
        });
      }

      getData("auth/get_login_token", app).then((result) => {
        let responseJson = result;
        if (responseJson.data) {
          if (result["status"] == 200) {
            var aToken = result["data"];
            localStorage.setItem("aToken", aToken);
            var main_link = "https://academosedutech.com/panel/admin";
            var dayplan_link = "https://academosedutech.com/panel/dayplan";
            this.setState({
              main_link: main_link,
              dayplan_link: dayplan_link,
              aToken: aToken,
            });
          } else {
            var aToken = "null";
            localStorage.setItem("aToken", aToken);
            var main_link = "https://academosedutech.com/panel/admin";
            var dayplan_link = "https://academosedutech.com/panel/dayplan";
            this.setState({
              main_link: main_link,
              dayplan_link: dayplan_link,
              aToken: aToken,
            });
          }
        }
      });
      getData("erp/school_details", app).then((result) => {
        let responseJson = result;
        if (responseJson.data) {
          if (result["status"] == 200) {
            this.setState({
              school_list: result["data"],
              school_name: result["data"]["0"]["school_name"],
              name: result["data"]["0"]["name"],
              locality: result["data"]["0"]["locality"],
              city: result["data"]["0"]["city"],
              logo: result["data"]["0"]["logo"],
            });
          } else {
            this.setState({
              school_list: [],
            });
          }
        }
      });
      getData("erp/master_school_list", app).then((result) => {
        let responseJson = result;
        if (responseJson.data) {
          if (result["status"] == 200) {
            this.setState({
              master_school_list: result["data"],
            });
          } else {
            this.setState({
              master_school_list: [],
            });
          }
        }
      });
      getData("erp/check_notification_count", app).then((result) => {
        let responseJson = result;
        if (result["status"] == 200) {
          this.setState({
            notification_count: result["count"],
          });
        } else {
          this.setState({
            notification_count: 0,
          });
        }
      });
    }
  }

  handleClick = (e) => {
    console.log("click ", e);
    this.setState({ current: e.key });
  };

  errorShow = (e) => {
    this.setState({
      error_visible: false,
      error_text: e,
    });
  };

  handleEmailOk = (e) => {
    var dashboard_location = window.location.href.split("/")[3];
    this.setState({
      error_visible: false,
      error_text: "",
    });
    if (dashboard_location != "home-dashboard") {
      window.location.href = "/";
    }
  };

  punch_in() {
    const result = window.confirm("Are you sure. You want to Check In !!!");
    if (result) {
      if (localStorage.getItem("schoolData")) {
        var storedArray = JSON.parse(localStorage.getItem("schoolData"));
        var user_id = storedArray["data"][0]["user_id"];
        var school_id = storedArray["data"][0]["school_id"];
        var app = { user_id: user_id, school_id: school_id };
        getKCISData("Kidzonia_school/staff_attendance_mark", app).then(
          (result) => {
            let responseJson = result;
            if (result["status"] == 200) {
              message.config({ top: 50 });
              message.success("Checked In Successfully !!!");
              setTimeout(() => {
                this.checkData();
              }, 100);
            } else {
              this.errorShow(result["message"]);
            }
          }
        );
      }
    }
  }

  showstaff = () => {
    if (localStorage.getItem("schoolData")) {
      var storedArray = JSON.parse(localStorage.getItem("schoolData"));
      var user_id = storedArray["data"][0]["user_id"];
      var school_id = storedArray["data"][0]["school_id"];
      var app = { user_id: user_id, school_id: school_id };
      getKCISData("Kidzonia_school/get_checkout_details", app).then(
        (result) => {
          let responseJson = result;
          if (result["status"] == 200) {
            this.setState({
              data_list: result["data"],
              staff_visible: true,
            });
            if (result["data"].length > 0) {
              this.setState({
                modalwidth: 1100,
              });
            }
          } else {
            this.errorShow(result["message"]);
          }
        }
      );
    }
  };

  handleStafOk = (e) => {
    this.setState({
      staff_visible: false,
    });
  };

  handleStaffCancel1 = (e) => {
    this.setState({
      staff_visible: false,
    });
  };

  sendStaffData = (e) => {
    if (localStorage.getItem("schoolData")) {
      var storedArray = JSON.parse(localStorage.getItem("schoolData"));
      var user_id = storedArray["data"][0]["user_id"];
      var school_id = storedArray["data"][0]["school_id"];
      var app = {
        school_id: school_id,
        user_id: user_id,
        data: this.state.data_list,
        today_details: this.state.today_details,
      };
      getKCISData("Kidzonia_school/daily_staff_report", app).then((result) => {
        let responseJson = result;
        if (result["status"] == 200) {
          message.config({ top: 50 });
          message.success("Checked Out Successfully !!!");
          setTimeout(() => {
            this.checkData();
          }, 100);
          this.setState({
            staff_visible: false,
            loading: false,
            today_details: "",
            data_list: [],
          });
        } else {
          this.errorShow(result["message"]);
        }
      });
    }
    this.setState({
      staff_visible: false,
    });
  };

  updateTopics = (event, index_val) => {
    var temp = this.state.data_list.map((data, index) => {
      if (index_val == index) {
        return { ...data, topics_sub: event.target.value };
      }
      return data;
    });
    setTimeout(() => {
      this.setState({
        data_list: temp,
      });
    }, 300);
  };

  updateTeaching = (event, index_val) => {
    var temp = this.state.data_list.map((data, index) => {
      if (index_val === index) {
        return { ...data, teaching_aid: event.target.value };
      }
      return data;
    });
    setTimeout(() => {
      this.setState({
        data_list: temp,
      });
    }, 300);
  };

  updateProcedure = (event, index_val) => {
    var temp = this.state.data_list.map((data, index) => {
      if (index_val === index) {
        return { ...data, procedures: event.target.value };
      }
      return data;
    });
    setTimeout(() => {
      this.setState({
        data_list: temp,
      });
    }, 300);
  };

  handleKeyUp = (event) => {
    console.log("check:", event.target.value);
    this.setState({ today_details: event.target.value });
  };

  render() {
    const { aToken } = this.state;
    if (localStorage.getItem("schoolData") && this.state.is_app == false) {
      const { placement, visible } = this.state;
      const { current } = this.state;
      const { aToken } = this.state;
      return (
        <>
          <Modal
            title="Error"
            visible={this.state.error_visible}
            className="error-modal"
          >
            <div class="col col-md-12 s12">
              <img src={delete_img} class="delete-img" alt="image" />
              <h2 class="mt-2">Error !</h2>
              <h4 class="mt-2">{this.state.error_text}</h4>
            </div>
            <div class="col col-md-12 s12 center mt-20">
              <Button
                className="btn btn-primary mr-2"
                onClick={this.handleEmailOk.bind(this)}
              >
                OK
              </Button>
            </div>
          </Modal>

          <Modal
            title="Daily Staff Details"
            visible={this.state.staff_visible}
            className="missed-followup-modal"
            onOk={this.handleStafOk}
            onCancel={this.handleStaffCancel1}
            width={this.state.modalwidth}
          >
            {this.state.data_list.length == 0 ? (
              <>
                <div class="col col-md-12 s12 no-padd mb-20 mt-20">
                  <label>
                    <b>Work details</b>
                  </label>
                  <TextArea
                    rows={6}
                    value={this.state.today_details}
                    onChange={this.handleKeyUp}
                  />
                </div>
              </>
            ) : (
              <>
                <div class="col col-md-12 s12 no-padd">
                  <div class="table-responsive">
                    <table class="table table-striped table-bordered table-hover">
                      <thead>
                        <tr>
                          <th>Lecture Time</th>
                          <th>Subject</th>
                          <th>Topics / Sub-Topics</th>
                          <th>Teaching Aid</th>
                          <th>Procedure / Methodology</th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                      {this.state.data_list.map((list, index) => (
                        <>
                          <tr>
                            <td>{list.timing}</td>
                            <td>{list.subject}</td>
                            <td>
                              <TextArea
                                rows={3}
                                onChange={(value) =>
                                  this.updateTopics(value, index)
                                }
                              />
                            </td>
                            <td>
                              <TextArea
                                rows={3}
                                onChange={(value) =>
                                  this.updateTeaching(value, index)
                                }
                              />
                            </td>
                            <td>
                              <TextArea
                                rows={3}
                                onChange={(value) =>
                                  this.updateProcedure(value, index)
                                }
                              />
                            </td>
                          </tr>
                        </>
                      ))}
                    </table>
                  </div>
                </div>
              </>
            )}

            <div class="col col-md-12 s12 center mt-20 mb-20">
              <Button
                className="btn btn-primary mr-2"
                onClick={this.sendStaffData.bind(this)}
                loading={this.state.loading}
              >
                Submit
              </Button>
            </div>
          </Modal>

          <aside
            id="layout-menu"
            class="layout-menu menu-vertical menu"
            data-bs-theme="dark"
          >
            <div class="app-brand demo ">
              <a href={`${process.env.PUBLIC_URL}/`} class="app-brand-link">
                <span class="topnav-logo-lg">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/img/logo.png`}
                    alt=""
                    height="60"
                  />
                </span>
              </a>
            </div>
            <div class="menu-inner-shadow"></div>

            <ul class="menu-inner py-1">
              <li class="menu-item">
                <a href="/" class="menu-link">
                  <i class="menu-icon icon-base ti tabler-home"></i>
                  <div data-i18n="Dashboards">Dashboards</div>
                </a>
              </li>

              {(this.state.type === "admin" ||
                this.state.type === "school" ||
                this.state.type === "staff" ||
                (this.state.permission &&
                  this.state.permission.find(function (element) {
                    return [1, 2, 9].indexOf(element) !== -1;
                  }))) && (
                <li className="menu-header small">
                  <span className="menu-header-text" data-i18n="Apps & Pages">
                    Order & Inventory
                  </span>
                </li>
              )}

              {(this.state.type === "admin" ||
                this.state.type === "school" ||
                this.state.type === "staff" ||
                (this.state.permission &&
                  this.state.permission.find(function (element) {
                    return element === 1;
                  }))) && (
                <li class="menu-item">
                  <a
                    href={`/shop?t=${aToken}&s=${this.state.erp_id}`}
                    className="menu-link"
                  >
                    <i class="menu-icon icon-base ti tabler-clipboard-text"></i>
                    <div data-i18n="Order Inventory Items">Order Inventory Items</div>
                  </a>
                </li>
              )}

              {(this.state.type === "admin" ||
                this.state.type === "school" ||
                this.state.type === "staff" ||
                (this.state.permission &&
                  this.state.permission.find(function (element) {
                    return element === 2;
                  }))) && (
                <li class="menu-item">
                  <a
                    href={`/panel/admin/individual-inventory?t=${aToken}&s=${this.state.erp_id}`}
                    className="menu-link"
                  >
                    <i class="menu-icon icon-base ti tabler-clipboard-data"></i>
                    <div data-i18n="Order Summary">Order Summary</div>
                  </a>
                </li>
              )}

              {(this.state.type === "admin" ||
                this.state.type === "school" ||
                this.state.type === "staff" ||
                (this.state.permission &&
                  this.state.permission.find(function (element) {
                    return element === 9;
                  }))) && (
                <li class="menu-item">
                  <a
                    href={`/panel/admin/products?t=${aToken}&s=${this.state.erp_id}`}
                    className="menu-link"
                  >
                    <i class="menu-icon icon-base ti tabler-file-check"></i>
                    <div data-i18n="Inventory">Inventory</div>
                  </a>
                </li>
              )}

              {(this.state.type === "admin" ||
                this.state.type === "school" ||
                this.state.type === "staff" ||
                (this.state.permission &&
                  this.state.permission.find(function (element) {
                    return [4, 5, 6].indexOf(element) !== -1;
                  }))) && (
                <li className="menu-header small">
                  <span className="menu-header-text" data-i18n="Reports & Fees">
                    Reports & Fees
                  </span>
                </li>
              )}

              {(this.state.type === "admin" ||
                this.state.type === "school" ||
                this.state.type === "staff" ||
                (this.state.permission &&
                  this.state.permission.find(function (element) {
                    return element === 4;
                  }))) && (
                <li class="menu-item">
                  <a
                    href={`/panel/admin/manage-fees-curriculum?t=${aToken}&s=${this.state.erp_id}`}
                    className="menu-link"
                  >
                    <i class="menu-icon icon-base ti tabler-device-mobile-dollar"></i>
                    <div data-i18n="Create Fees Type">Create Fees Type</div>
                  </a>
                </li>
              )}

              {(this.state.type === "admin" ||
                this.state.type === "school" ||
                this.state.type === "staff" ||
                (this.state.permission &&
                  this.state.permission.find(function (element) {
                    return element === 5;
                  }))) && (
                <li className="menu-item">
                  <a
                    href={`/panel/admin/manage-fees?new_sc_id=?t=${aToken}&s=${this.state.erp_id}`}
                    className="menu-link"
                  >
                    <i className="menu-icon icon-base ti tabler-settings-check"></i>
                    <div data-i18n="Manage Fees">Manage Fees</div>
                  </a>
                </li>
              )}

              {(this.state.type === "admin" ||
                this.state.type === "school" ||
                this.state.type === "staff" ||
                (this.state.permission &&
                  this.state.permission.find(function (element) {
                    return element === 6;
                  }))) && (
                <li className="menu-item">
                  <a
                    href={`/reports/children-fees-report?t=${aToken}&s=${this.state.erp_id}`}
                    className="menu-link"
                  >
                    <i className="menu-icon icon-base ti tabler-file-analytics"></i>
                    <div data-i18n="Child Fees Report">Child Fees Report</div>
                  </a>
                </li>
              )}

              {(this.state.type === "admin" ||
                this.state.type === "school" ||
                this.state.type === "staff" ||
                (this.state.permission &&
                  this.state.permission.find(function (element) {
                    return element === 7;
                  }))) && (
                <li className="menu-item">
                  <a
                    href={`/fees-report/failed?t=${aToken}&s=${this.state.erp_id}`}
                    className="menu-link"
                  >
                    <i className="menu-icon icon-base ti tabler-report-money"></i>
                    <div data-i18n="Fees Report">Fees Report</div>
                  </a>
                </li>
              )}

              {(this.state.type === "admin" ||
                this.state.type === "school" ||
                this.state.type === "staff" ||
                (this.state.permission &&
                  this.state.permission.find(function (element) {
                    return [3, 8, 10].indexOf(element) !== -1;
                  }))) && (
                <li className="menu-header small">
                  <span className="menu-header-text" data-i18n="Staff & Access">
                    Staff & Access
                  </span>
                </li>
              )}

              {(this.state.type === "admin" ||
                this.state.type === "school" ||
                this.state.type === "staff" ||
                (this.state.permission &&
                  this.state.permission.find(function (element) {
                    return element === 3;
                  }))) && (
                <li className="menu-item">
                  <a
                    href={`/panel/admin/staff?t=${aToken}&s=${this.state.erp_id}`}
                    className="menu-link"
                  >
                    <i className="menu-icon icon-base ti tabler-users"></i>
                    <div data-i18n="Manage Staff">Manage Staff</div>
                  </a>
                </li>
              )}

              {(this.state.type === "admin" ||
                this.state.type === "school" ||
                this.state.type === "staff" ||
                (this.state.permission &&
                  this.state.permission.find(function (element) {
                    return element === 8;
                  }))) && (
                <li className="menu-item">
                  <a
                    href={`/panel/admin/access-list?t=${aToken}&s=${this.state.erp_id}`}
                    className="menu-link"
                  >
                    <i className="menu-icon icon-base ti tabler-lock"></i>
                    <div data-i18n="Manage Access">Manage Access</div>
                  </a>
                </li>
              )}

              {(this.state.type === "admin" ||
                this.state.type === "school" ||
                this.state.type === "staff" ||
                (this.state.permission &&
                  this.state.permission.find(function (element) {
                    return element === 10;
                  }))) && (
                <li className="menu-item">
                  <a
                    href={`/panel/admin/access-list?t=${aToken}&s=${this.state.erp_id}`}
                    className="menu-link"
                  >
                    <i className="menu-icon icon-base ti tabler-calendar-dollar"></i>
                    <div data-i18n="Head Office Expense">Head Office Expense</div>
                  </a>
                </li>
              )}
            </ul>
          </aside>

          <div class="layout-page">
            <nav
              class="layout-navbar container-xxl navbar-detached navbar navbar-expand-xl align-items-center bg-navbar-theme"
              id="layout-navbar"
            >
              <div class="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0   d-xl-none ">
                <a
                  class="nav-item nav-link px-0 me-xl-6"
                  href="javascript:void(0)"
                >
                  <i class="icon-base ti tabler-menu-2 icon-md"></i>
                </a>
              </div>
              <div
                class="navbar-nav-right d-flex align-items-center justify-content-end"
                id="navbar-collapse"
              >
                <div class="navbar-nav align-items-center">
                  <div class="nav-item navbar-search-wrapper px-md-0 px-2 mb-0">
                    <a
                      class="nav-item nav-link search-toggler d-flex align-items-center px-0"
                      href="javascript:void(0);"
                    >
                      <span
                        class="d-inline-block text-body-secondary fw-normal"
                        id="autocomplete"
                      ></span>
                    </a>
                  </div>
                </div>

                <ul className="navbar-nav flex-row align-items-center ms-md-auto">
                  <li className="nav-item navbar-dropdown dropdown-user dropdown">
                    <a
                      className="nav-link dropdown-toggle hide-arrow p-0"
                      href="javascript:void(0);"
                      data-bs-toggle="dropdown"
                    >
                      <div className="avatar avatar-online">
                        <img
                          src={this.state.profile_pic}
                          alt="user-avatar"
                          className="rounded-circle"
                        />
                      </div>
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end">
                      <li>
                        <a
                          className="dropdown-item mt-0"
                          href="javascript:void(0);"
                        >
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0 me-2">
                              <div className="avatar avatar-online">
                                <img
                                  src={this.state.profile_pic}
                                  alt="user-avatar"
                                  className="rounded-circle"
                                />
                              </div>
                            </div>
                            <div className="flex-grow-1">
                              <h6 className="mb-0">{this.state.user_name}</h6>
                              <small className="text-body-secondary">
                                {this.state.type === "admin" && "Master"}
                                {this.state.type === "school" && "School Admin"}
                                {this.state.type === "staff" &&
                                  this.state.staff_type}
                              </small>
                              <div>
                                <small>{this.state.email}</small>
                              </div>
                              <div>
                                <small>
                                  {this.state.phone !== ""
                                    ? this.state.phone
                                    : "-"}
                                </small>
                              </div>
                            </div>
                          </div>
                        </a>
                      </li>

                      {this.state.type === "admin" && (
                        <>
                          <li>
                            <div className="dropdown-divider my-1 mx-n2"></div>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item"
                              to={`${process.env.PUBLIC_URL}/consolidated-report`}
                            >
                              <i className="icon-base ti tabler-message me-3 icon-md"></i>
                              <span className="align-middle">Email Report</span>
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item"
                              to={`${process.env.PUBLIC_URL}/admin-change-password`}
                            >
                              <i className="icon-base ti tabler-lock me-3 icon-md"></i>
                              <span className="align-middle">
                                Change Password
                              </span>
                            </Link>
                          </li>
                        </>
                      )}

                      <li>
                        <div className="d-grid px-2 pt-2 pb-1">
                          <button
                            className="btn btn-sm btn-danger d-flex"
                            onClick={this.logout.bind(this)}
                          >
                            <small className="align-middle">Logout</small>
                            <i className="icon-base ti tabler-logout ms-2 icon-14px"></i>
                          </button>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </nav>
          </div>

          {this.state.is_slow_internet == true && (
            <>
              <span class="slow-network">
                Your internet connection is slow !!!
              </span>
            </>
          )}

          {this.state.isOnline == false && (
            <>
              <Modal
                title="Basic Modal"
                visible={this.state.visible_1}
                className="internet-notworking"
                onOk={this.handleOk}
                onCancel={this.handleCancel}
              >
                <div class="int">
                  <img src={wifi} className="" />
                  <p> No internet Connection !!!</p>
                </div>
              </Modal>
            </>
          )}
        </>
      );
    } else {
      return <></>;
    }
  }
}
export default connect(mapStateToProps)(Header);
